import { Route } from '@angular/router';
import { provideStates } from '@ngxs/store';
import { isGreenlandUserGuard } from '@shared/guards/is-greenland-user.guard';
import { RouteNames } from '../../route-names';
import { CargoCalculationComponent } from './cargo-calculation.component';
import { CargoCalculationState } from './store/cargo-calculation.state';

export const CARGO_ON_THE_WAY_ROUTE: Route = {
  title: 'В пути',
  path: RouteNames.CARGO_ON_THE_WAY_PAGE.concat('/:id'),
  component: CargoCalculationComponent,
  canActivate: [isGreenlandUserGuard],
  providers: [provideStates([CargoCalculationState])],
};
